import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const HUB_ACCESS_TOKEN_KEY = "presence-hub-access-token";
export const HUB_AUTH_EXPIRED_EVENT = "presence-hub-auth-expired";

axiosClient.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(HUB_ACCESS_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      sessionStorage.removeItem(HUB_ACCESS_TOKEN_KEY);
      window.dispatchEvent(new Event(HUB_AUTH_EXPIRED_EVENT));
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
